"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APIconButton = _interopRequireDefault(require("../common/APIconButton/APIconButton"));
var _APIFrame = _interopRequireDefault(require("../common/APIFrame/APIFrame"));
require("./DigitalAssetsOfferingProfilePage.css");
var _TotalTokensCount = require("./TotalTokensCount");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var classes = (0, _cssClassesHelper.getBEMClasses)('offering-profile');
var DigitalAssetsOfferingProfilePage = function DigitalAssetsOfferingProfilePage(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  var ProductId = props.ProductId,
    OfferingProfileURL = props.OfferingProfileURL,
    price = props.price,
    digitalAsset = props.digitalAsset,
    isWithdrawDisabled = props.isWithdrawDisabled,
    openSendReceiveSidePane = props.openSendReceiveSidePane,
    selectInstrument = props.selectInstrument,
    selectedInstrumentId = props.selectedInstrumentId;
  var product = digitalAsset;
  (0, _react.useEffect)(function () {
    if (selectedInstrumentId && ProductId) {
      selectInstrument(selectedInstrumentId);
      props.getProductAttributes([{
        ProductId: ProductId
      }]);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedInstrumentId, ProductId]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, product && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('header')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('left')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes('symbol')
  }, digitalAsset.Product), "\xA0\xA0\xA0", /*#__PURE__*/_react["default"].createElement("span", {
    className: classes('product')
  }, digitalAsset.ProductFullName)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('right')
  }, /*#__PURE__*/_react["default"].createElement(_APIconButton["default"], {
    iconName: 'deposit',
    action: function action() {
      openSendReceiveSidePane(digitalAsset);
    },
    customClass: classes('padding'),
    label: t('   Buy')
  }), "\xA0\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_APIconButton["default"], {
    style: {
      border: '1px solid red'
    },
    iconName: 'withdraw',
    action: function action() {
      openSendReceiveSidePane(digitalAsset, '1');
    },
    customClass: classes('padding'),
    isDisabled: isWithdrawDisabled,
    label: t('   Sell')
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('header')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('left')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes('tabs')
  }, t('Asset Details'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('right')
  }, t('Price:'), " $", price, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), t('Number of tokens for sale:'), /*#__PURE__*/_react["default"].createElement(_TotalTokensCount.ConnectedTotalTokens, {
    ProductId: ProductId,
    InstrumentId: selectedInstrumentId
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('iframe-container')
  }, /*#__PURE__*/_react["default"].createElement(_APIFrame["default"], {
    src: OfferingProfileURL,
    title: digitalAsset.Product,
    style: {
      width: '100%',
      height: '100%'
    }
  })))));
};
var _default = exports["default"] = DigitalAssetsOfferingProfilePage;